var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.204 39.047a2.297 2.297 0 114.594 0 2.297 2.297 0 01-4.594 0zM24.5 15.313c.846 0 1.532.686 1.532 1.531v15.313a1.531 1.531 0 01-3.062 0V16.845c0-.846.685-1.532 1.53-1.532z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22.2.536a5.218 5.218 0 016.984 2.383l19.34 39.397A4.638 4.638 0 0144.36 49H4.64a4.636 4.636 0 01-4.163-6.682L19.817 2.92A5.212 5.212 0 0122.2.536zm4.236 3.733a2.156 2.156 0 00-3.87 0l-19.34 39.4a1.575 1.575 0 001.414 2.268h39.721a1.576 1.576 0 001.416-2.267L26.436 4.27z","key":1})]);
}

Warning.defaultProps = {"viewBox":"0 0 49 49"};

module.exports = Warning;

Warning.default = Warning;
